import { get } from "lodash";
import basket from "@irati/checkout/utils/basket";
export default function willReachMaxAmount(deal, productId) {
    var _a;
    var _b = maxAllowedAmount(deal, productId), hasLimit = _b.hasLimit, maxAllowed = _b.maxAllowed, dealProductConfig = _b.dealProductConfig;
    if (!hasLimit) {
        return false;
    }
    var currentProductTotal = ((_a = basket.items.find(function (basketItem) { return basketItem.productId === productId; })) === null || _a === void 0 ? void 0 : _a.amount) || 0;
    var totalAfter = currentProductTotal + ((dealProductConfig === null || dealProductConfig === void 0 ? void 0 : dealProductConfig.salePrice.value) || 0);
    return maxAllowed > totalAfter;
}
export function maxAllowedAmount(deal, productId) {
    var limits = get(deal, "productConfig.limits.perRedemption", false);
    var maxAllowed = limits.maxPriceBeforeDiscounts;
    var dealProductConfig = deal.productConfig.products.find(function (prod) { return prod.uuid === productId; });
    if (!limits || !maxAllowed || !dealProductConfig) {
        return { hasLimit: false };
    }
    return { hasLimit: true, maxAllowed: maxAllowed, dealProductConfig: dealProductConfig };
}
